var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnassigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 60,
    viewBox: "0 0 512 512",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m266.666667 128c64.80141 0 117.333333 52.531923 117.333333 117.333333 0 24.693186-7.627964 47.604765-20.656081 66.506928l59.884556 59.884992-30.169889 30.169889-59.884992-59.884557c-18.902163 13.028118-41.813742 20.656082-66.506927 20.656082-64.801411 0-117.333334-52.531923-117.333334-117.333334 0-64.80141 52.531923-117.333333 117.333334-117.333333zm0 42.666667c-41.237262 0-74.666667 33.429405-74.666667 74.666666 0 41.237262 33.429405 74.666667 74.666667 74.666667 41.237261 0 74.666666-33.429405 74.666666-74.666667 0-41.237261-33.429405-74.666666-74.666666-74.666666zm-138.262428 63.998909c-.26786 3.5208-.404239 7.078352-.404239 10.667757 0 11.014287 1.284152 21.728643 3.710904 32.001518l-131.710904-.001518v-42.666666zm-43.0709057-234.665576v213.333333h-64v-213.333333zm85.3333337 85.3333333-.00272 59.9401497c-18.930213 18.167331-32.715709 41.654591-38.953043 68.058332l-25.044237.001518v-127.9999997zm85.333333-42.6666666-.000404 64.4041873c-23.445281 1.783582-45.260868 9.397436-64.000144 21.394945l.000548-85.7991323zm85.333333 21.3333333.00065 64.465865c-18.739115-11.99743-40.554496-19.611277-63.999559-21.394959l-.001091-43.070906z",
    fillRule: "evenodd",
    fill: "#4D6E61",
    transform: "translate(42.666667 64)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassigned);
export default __webpack_public_path__ + "static/media/unassigned.edbe728ec80bc75aeb102c200e3e68fd.svg";
export { ForwardRef as ReactComponent };